module.exports = __webpack_public_path__ + "img/medpage_today_icon.e50b583c.svg";